import axios from 'axios';

// 登錄请求119.45.104.182方法 http://175.178.236.208:8080/  http://brand.lywpcx.top:8080/
const baseURL = 'https://hk.lywpcx.top';
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url:baseURL+url,
        headers: {
            'Content-Type': 'application/json', // 修改为 application/json
        },
        data: params, // 直接传递对象
    });
};
// 通用公用方法
const req = (method, url, params) => {
    return axios({
        method: method,
        url:baseURL+url,
        headers: {
            'Content-Type': 'application/json', // 修改为 application/json
            'Authorization': `Bearer ${localStorage.getItem('logintoken')}`,
        },
        data: params, // 直接传递对象
    });
};
// 适合 GET 方法的 req2
const req2 = (method, url, params) => {
    // 处理 GET 请求的查询参数
    let queryString = '';
    if (params) {
        queryString = Object.keys(params)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');
        url += `?${queryString}`;
    }

    return axios({
        method: method,
        url:baseURL+url,
        headers: {
            'Content-Type': 'application/json', // 修改为 application/json
            'Authorization': `Bearer ${localStorage.getItem('logintoken')}`,
        },
    });
};

// 新增上传图片的方法
const uploadImage = (method,url, params) => {
    return axios({
        method: method,
        url:baseURL+url,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${localStorage.getItem('logintoken')}`
        },
        data: params
    });
};


const exportExcel = (method, url, params) => {
    let queryString = '';
    if (params) {
        queryString = Object.keys(params)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');
        url += `?${queryString}`;
    }
    return axios({
        method: method,
        url:baseURL+url,
        headers: {
            'Content-Type': 'application/json', // 修改为 application/json
            'Authorization': `Bearer ${localStorage.getItem('logintoken')}`,
          
            
        },
        responseType: 'blob', // 设置响应类型为 blob
        data: params
    });
};
export {
    loginreq,
    req,
    req2,
    uploadImage,
    exportExcel
};